<template>
    <div id="content">
        <b-card id="section">

            <!-- Header display -->
            <div class="m-1 mb-3 p-1 text-center">
                <img width="64px" height="64px" src="../../assets/navlogo.png" class="my-3" >
                <h5>VO2 Master Cloud</h5>
            </div>

            <!-- Shown when loading -->
            <div v-if="isLoading" class="text-center">
                <b-spinner small type="grow"></b-spinner>
                Loading...
            </div>

            <!-- Shown when error -->
            <b-alert v-else-if="isError" variant="warning" class="m-5" show>
                <p><span>There was a problem connecting to the platform.</span></p>
                <ul>
                    <li><span>Check your network connection.</span></li>
                    <li><span>Please refresh your browser and try again.</span></li>

                    <!--
                    <li><span>connection: {{!errorConnection}} </span></li>
                    <li><span>authorized: {{!errorAuthorize}} </span></li>
                    <li><span>site login: {{!errorSiteLogin}} </span></li>
                    -->

                </ul>
                <b-button class="text-center" size="sm" variant="primary" v-on:click.stop="onRetry()">Retry</b-button>
            </b-alert>

            <div v-else class="text-center">
            </div>

        </b-card>

    </div>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex'


    export default {
        name: "LoginPage",
        components: {
        },
        data() {
            return {
                redirectPath: this.$route.params.redirectPath,

                errorConnection: false,
                errorSiteLogin: false,
                errorAuthorize: false,
                loginBusy: false,
            }
        },
        created () {

            if (!this.$auth.loading) {
                return this.performLogin();
            }

            this.$auth.$watch("loading", loading => {
                if (loading === false) {
                    if(this.$auth.error) {
                        this.errorAuthorize = true;
                    }

                    return this.performLogin();
                }
            });
        },
        computed: {
            ...mapGetters({
                userAccount: 'userAccount/current',
            }),

            isLoading() {
                return this.loginBusy || this.$auth.loading || this.$auth.processingRedirect;
            },

            isError() {
                if(this.isLoading)
                    return false;

                return this.errorConnection || this.errorAuthorize || this.errorSiteLogin;
            }

        },
        methods: {
            ...mapActions({
                 pingServer: "server/ping",
                 userAccountLogin: "userAccount/login",
            }),

            onRetry() {
                window.location.replace( process.env.VUE_APP_API_URL);
            },

            async performLogin() {

                let self = this;
                if(self.loginBusy) {
                    return;
                }
                self.loginBusy = true;

                console.log('performLogin');

                //clear error flags
                self.errorConnection = false;
                self.errorSiteLogin = false;
                self.errorAuthorize = false;

                try {
                  await self.checkConnection();
                } catch(err) {
                  self.errorConnection = true;
                  console.log(err);

                  self.loginBusy = false;
                  return;
                }

                try {

                    await self.authorize();
                    await self.siteLogin();

                    let authOk = self.$auth.isAuthenticated;

                    if (authOk && self.userAccount) {

                        let orgId = null;
                        if(self.userAccount.userSettings.defaultOrganizationId) {
                            orgId = self.userAccount.userSettings.defaultOrganizationId;
                        }

                        let user = self.userAccount;

                        //require agreements
                        if(!user.termsAccepted) {
                          await self.$router.push({name: 'Agreement' , params: {agreementType: 'termsOfUse'}});
                        } else if(!user.privacyAccepted) {
                          await self.$router.push({name: 'Agreement' , params: {agreementType: 'privacy'} });
                        } else if(self.isUserAccountSetupComplete()) {
                            if(this.redirectPath) {
                              await self.$router.push({path: this.redirectPath});
                            } else {
                              await self.$router.push({name: 'Dashboard', params: {orgId: orgId}});
                            }
                        } else {
                            await self.$router.push({name: 'UserSetup', params: {orgId: orgId}});
                        }

                    } else {
                        //try again.
                        self.errorSiteLogin = true;
                    }

                } catch(err) {
                    self.errorAuthorize = true;
                    console.log(err);
                } finally {
                    self.loginBusy = false;
                }
            },

            isUserAccountSetupComplete() {
                let current = this.userAccount;
                if(current) {
                    let first = current.firstName !== undefined &&  current.firstName != '';
                    let email = current.emailAddress !== undefined && current.emailAddress != '';
                    let orgId = current.userSettings.defaultOrganizationId !== undefined && current.userSettings.defaultOrganizationId != '';

                    return first && email && orgId;
                }

                return false;
            },

            checkConnection() {
               let self = this;
               return self.pingServer();
            },
            authorize() {
                let self = this;

                if(self.$auth.isAuthenticated) {
                    return new Promise(function(resolve) { resolve(true); });
                } else {
                    return self.$auth.loginWithRedirect();
                }
            },
            siteLogin() {
                let self = this;
                return self.userAccountLogin();
            }
        }
    }
</script>

<style scoped>

    #content {
        display: flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        color: #000;
        width:100%;
        height:100%;
        margin:0px;
    }

    #section {
        padding: 20px 80px;
    }

</style>